<template>
  <div class="grid grid-cols-1 content-center flex flex-col sm:flex-col-reverse">
    <div class="m-auto">
      <img class="animate__animated animate__slideInDown" style="width: 150px; height: 150px" src="../assets/images/logo.png" alt="logo" />
    </div>
    <h1 class="text-center text-4xl animate__animated animate__slideInDown">
        Thank You
    </h1>
  </div>
</template>

<script>

export default {
  name: 'ThankYou',
  components: {
  },
  methods: {
    answerEnter(e) {
      if (e.keyCode == 13) {
        this.submit();
      } else {
        this.error = false;
      }
    },
  },
  created() {
  },
}
</script>

<style>
</style>